<script>

    import { toast } from 'bulma-toast'

    import ZipcodesService from '../$services/zipcodes.service'

    import InputText from '../$components/input.text.svelte'
    import Spinner from '../$components/spinner.svelte'
    import Select from '../$components/select.svelte'

    export let zipcode = null
    export let state = null
    export let city = null
    export let municipality = null
    export let colony = null
    export let colonyCode = null

    export let readonly = false

    let colonies = []
    let loading = false
    let showInput = false

    async function findZipcode() {

        if(readonly)
            return

        state = ''
        city = ''
        municipality = ''
        colony = ''
        colonies = []
        showInput = false

        if(zipcode.length != 5)
            return

        loading = true
        const resp = await ZipcodesService.getZipcode(zipcode)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        if(!resp.data)
            return toast({message: 'No se encontro información del código postal', type: 'is-danger'})

        state = resp.data.state || ''
        city = resp.data.city || ''
        municipality = resp.data.municipality || ''

        colonies = resp.data.colonies || []
    }

    function setColonyCode() {
        colonyCode = colonies.find(item => item.name === colony).code
    }

</script>

<Spinner {loading} />

{#if !loading}
    <div class="columns">
        <div class="column">
            <InputText bind:value={zipcode} on:keyup={findZipcode} label="Código postal" icon="map-marker-alt" placeholder="Código postal" readonly={readonly} disabled={readonly} />
        </div>
        <div class="column">
            <InputText bind:value={state} label="Estado" icon="map-marker-alt" placeholder="Estado" readonly={readonly}/>
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={city} label="Ciudad" icon="city" placeholder="Ciudad" />
        </div>
        <div class="column">
            <InputText bind:value={municipality} label="Municipio" icon="map-marker-alt" placeholder="Municipio" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <div class="items end">
                <Select bind:value={colony} { readonly } label="Colonia" icon="map-marker-alt" 
                    on:change={ setColonyCode }
                    options={colonies.map(item =>{
                        return {value: item.name, text: item.name}
                    })}
                />
            </div>
        </div>
    </div>
{/if}